import { useIntl } from "react-intl";
function useMessageFormatter() {
  const { formatMessage } = useIntl();
  return (text, values) => {
    return text ? typeof text === "string" ? text : formatMessage(text, values) : "";
  };
}
const isMessageDescriptor = (message) => {
  return message && message.defaultMessage !== void 0;
};
function useCurrencySymbol() {
  const currency = "USD";
  const { formatNumberToParts } = useIntl();
  return formatNumberToParts(0, { format: currency }).find((p) => p.type === "currency")?.value;
}
export {
  isMessageDescriptor,
  useCurrencySymbol,
  useMessageFormatter
};
//# sourceMappingURL=hooks.js.map
